/* istanbul ignore file */
import { createUseStyles } from '@glu/theming';

const styles = () => ({
  styledContainer: {
    marginTop: -1,
  },
});

export default createUseStyles(styles);
